var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGardooneh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 49,
    viewBox: "0 0 55 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "png-transparent-computer-icons-solitaire-chess-finish-game-white-text-01 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.73443 25.1509C6.70931 13.8034 16.0563 4.43845 27.4164 4.4297C39.0955 4.4197 48.4287 13.5909 48.4601 25.0959C48.4782 27.8306 47.9524 30.5419 46.9132 33.0734C45.8739 35.605 44.3417 37.9069 42.4048 39.8464C40.4679 41.786 38.1646 43.3249 35.6275 44.3745C33.0905 45.4242 30.3699 45.9637 27.6224 45.9622C16.0187 45.9697 6.75954 36.7434 6.73443 25.1509ZM27.5521 44.1372C32.8353 44.0009 37.2532 42.2359 40.9692 38.6372L27.8735 25.4359L27.9991 25.1922H46.5488C46.8803 20.8272 44.2456 14.5522 40.8838 11.7922L27.6387 25.0022V6.3772C23.6201 5.8572 16.845 8.64345 13.9993 12.1709L27.3298 24.9334L27.2117 25.1697H8.56917C8.68722 30.4097 10.4931 34.7947 14.4338 38.8609L27.5521 25.2709V44.1372Z",
    fill: "url(#paint0_linear_238_1577)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_238_1577",
    x1: 13.3058,
    y1: 11.752,
    x2: 43.8227,
    y2: 38.8925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF646C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGardooneh);
export default __webpack_public_path__ + "static/media/gardooneh.d220b5632ac88156dd232a43b23a62b7.svg";
export { ForwardRef as ReactComponent };